import classNames from 'classnames';
import { PercentProps } from 'components/shared/Percent/model';
import { Percent, PercentSkeleton } from 'components/shared/Percent/Percent';
import { WithUnit, WithUnitProps } from 'components/shared/WithUnit/WithUnit';
import { FC } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

export const PercentWithUnit = (props: PercentProps & WithUnitProps & { showUnit?: boolean }) => {
  const {
    unit = '%',
    units: _,
    children,
    highlightColor,
    tabIndex,
    showUnit = true,
    className,
    isFocused,
    unitClassName,
    ...percentProps
  } = props;
  const intl = useIntl();

  return (
    <WithUnit
      unit={getUnit(unit, intl)}
      unitsDirection="down"
      e2e={props.e2e}
      unitClassName={unitClassName}
      unitE2e="unit"
      maxWidth={props.maxWidth}
      minWidth={props.minWidth}
      className={classNames(props.className, 'percent-with-unit-component', {
        'is-highlighted-success': highlightColor === 'success',
        'is-highlighted-info': highlightColor === 'info',
        'is-highlighted-turquoise': highlightColor === 'turquoise',
      })}
      title={props.title}
      showUnit={showUnit}
    >
      {children}
      <Percent
        {...percentProps}
        e2e={percentProps.e2e + '-input'}
        id={props.id ?? props.e2e}
        className={className}
        tabIndex={tabIndex}
        isFocused={isFocused}
        onBlur={percentProps.onBlur}
        onFocus={percentProps.onFocus}
        onChange={percentProps.onChange}
      />
    </WithUnit>
  );
};

export const PercentWithUnitSkeleton: FC = () => {
  return (
    <div className="percent-with-unit-component input-group">
      <PercentSkeleton />
      <span className="unit input-group-text">
        <Skeleton width="1em" />
      </span>
    </div>
  );
};

function getUnit(unit: string, intl: IntlShape): string {
  switch (unit) {
    case '% PA':
      return intl.formatMessage({ id: 'form.unit.% PA', defaultMessage: '% PA' });
    case '% PP':
      return intl.formatMessage({ id: 'form.unit.% PP', defaultMessage: '% PP' });
    default:
      return unit;
  }
}
